export { RegisterAdmin } from "./ui";
